// Obtención del token:

// - Si no existe el token logeamos con usuario demo
// - Si existe el token hacemos un refresh
//     - si el refresh es correcto mostramos pantalla
//     - si el refresh es fallido mostramos error y logeamos con usuario demo

import axios from 'axios'
import store from '@/store/index'
import router from '@/router/index'
import * as CONSTANTS from '@/utils/constants'
require('es6-promise/auto')

let URLSearchParams = require('url-search-params')
export const instance = axios.create()

// axios.defaults.headers.common['Content-Type'] = 'application/json';
// axios.defaults.headers.common['Accept'] = 'application/json';

// base url
instance.defaults.baseURL = CONSTANTS.apiRoot

// Add a request interceptor
instance.interceptors.request.use(
  config => {
    const token = store.getters.getToken
    if (token) { config.headers.common['Authorization'] = 'Bearer ' + token }
    return config
  },
  error => {
    Promise.reject(error)
  })

// Add a response interceptor
instance.interceptors.response.use(
  response => {
    return response
  },
  error => {
    // Unauthorized
    if (error.response.status === 401) {
      const accessToken = localStorage.getItem('access_token')
      const refreshToken = localStorage.getItem('refresh_token')
      const azureUser = localStorage.getItem('azure_user')

      if (accessToken && refreshToken) {
        if (!azureUser) {
          return this.refreshToken(refreshToken).then(res => {
            if (res.data === 'restart' && store.getters.user) {
              // el refrest token ha fallado y se ha realizado getToken
              return getUser().then(response => {
                store.commit('setUser', response.data['results'][0])
                router.push({name: 'welcome'})
                return Promise.reject(error)
              })
            } else {
              // si es el usuario demo realizamos de nuevo la llamada fallida con nuevo token
              error.response.config.headers['Authorization'] = 'Bearer ' + store.getters.getToken
              return axios(error.response.config)
            }
          })
        } else {
          return this.refreshTokenAzure(refreshToken).then(res => {
            if (res.data === 'restart') {
              // el refrest token ha fallado y se ha realizado getToken
              return getUser().then(response => {
                store.commit('setUser', response.data['results'][0])
                router.push({name: 'welcome'})
                return Promise.reject(error)
              })
            } else {
              // refresh token correcto
              error.response.config.headers['Authorization'] = 'Bearer ' + store.getters.getToken
              return axios(error.response.config)
            }
          })
        }
      } else {
        return Promise.reject(error)
      }
    } else {
      return Promise.reject(error)
    }
  })

export function initApp () {
  let accessToken = localStorage.getItem('access_token')
  let refreshToken = localStorage.getItem('refresh_token')
  let azureUser = localStorage.getItem('azure_user')

  const urlParams = new URLSearchParams(window.location.search)
  const urlRefreshToken = urlParams.get('rt')
  const urlRefreshTokenAzure = urlParams.get('rta')

  // login desde back
  if (urlRefreshToken) {
    window.history.replaceState({}, '', location.pathname)
    return this.refreshToken(urlRefreshToken)
  }

  // login desde back con azure
  if (urlRefreshTokenAzure) {
    window.history.replaceState({}, '', location.pathname)
    return this.refreshTokenAzure(urlRefreshTokenAzure)
  }

  if (accessToken && refreshToken) {
    if (process.env.NODE_ENV !== 'development') {
      // url base
      if (azureUser) instance.defaults.baseURL = CONSTANTS.apiRootAzure

      store.commit('setToken', {
        accessToken: accessToken,
        refreshToken: refreshToken,
        azureUser: azureUser
      })

      return Promise.resolve(true)
    } else {
      return !azureUser ? this.refreshToken(refreshToken) : this.refreshTokenAzure(refreshToken)
    }
  } else {
    return this.getToken(false, false)
  }
}

export function getToken (username, password) {
  let data = new FormData()
  data.append('client_id', CONSTANTS.clientId)
  data.append('grant_type', 'password')
  !username ? data.append('username', CONSTANTS.username) : data.append('username', username)
  !password ? data.append('password', CONSTANTS.password) : data.append('password', password)

  return axios.post(CONSTANTS.apiRootLogin + 'o/token/', data)
    .then(response => {
      // remove old token
      if (store.getters.getToken) { this.logout(store.getters.getToken) }

      // base url
      instance.defaults.baseURL = CONSTANTS.apiRoot

      // guardamos token
      store.commit('setToken', {
        accessToken: response.data.access_token,
        refreshToken: response.data.refresh_token
      })
      return { data: 'restart' }
    })
}

export function refreshToken (refreshToken) {
  let data = new FormData()
  data.append('client_id', CONSTANTS.clientId)
  data.append('grant_type', 'refresh_token')
  data.append('refresh_token', refreshToken)

  return axios.post(CONSTANTS.apiRootLogin + 'o/token/', data)
    .then(response => {
      // guardamos token
      store.commit('setToken', {
        accessToken: response.data.access_token,
        refreshToken: response.data.refresh_token
      })

      return 1
    }).catch(() => {
      return this.getToken(false, false)
    })
}

export function refreshTokenAzure (refreshToken) {
  const params = {
    'refresh_token': refreshToken
  }

  return axios.get(CONSTANTS.apiRootAzure + 'vusers/azure_refresh_token/', {params: params})
    .then(response => {
      // servidor siempre devuelve 200, tenemos que comprobar si esta correcto
      if (response.data.access_token && response.data.refresh_token) {
        // url base
        instance.defaults.baseURL = CONSTANTS.apiRootAzure

        // guardamos token
        store.commit('setToken', {
          accessToken: response.data.access_token,
          refreshToken: response.data.refresh_token,
          azureUser: true
        })

        return 1
      } else {
        instance.defaults.baseURL = CONSTANTS.apiRoot
        return this.getToken(false, false)
      }
    }).catch(() => {
      // cambiamos baseurl normal
      instance.defaults.baseURL = CONSTANTS.apiRoot
      return this.getToken(false, false)
    })
}

export function getClient () {
  return instance.get('clients/')
    .then(response => {
      // guardamos client
      store.commit('setClient', response.data['results'][0])
    })
}

export function setDevice (latitude, longitude, name, type, uuid, system) {
  var data = {
    'latitude': latitude,
    'longitude': longitude,
    'name': name,
    'device_type': type,
    'id_device': uuid,
    'system_version': system
  }
  return instance.post('devices/', data)
}

export function setLink (dataDevice) {
  var data = {
    'device': dataDevice.id_device,
    'access_key': '',
    'refresh_key': '',
    'code': ''
  }
  return instance.post('links/', data)
}

export function getLink (code) {
  return instance.get('links/' + code + '/')
}

export function deleteLink (code) {
  return instance.delete('links/' + code + '/')
}

export function logout (token) {
  let body = new URLSearchParams()
  body.set('client_id', CONSTANTS.clientId)
  body.set('token', token)

  return instance.post(CONSTANTS.apiRootLogin + 'o/revoke_token/', body)
}

export function getUser () {
  return instance.get('vusers/')
}

// export function setUser (data) {
//   return instance.post(CONSTANTS.apiRoot + 'vusers/', data)
// }

// export function putUser (data) {
//   return instance.put(CONSTANTS.apiRoot + 'vusers/' + data.id + '/', data)
// }

export function getCards () {
  return instance.get('vusers/' + store.getters.user.id + '/cards/')
}

// export function setCard (data) {
//   return instance.put(CONSTANTS.apiRoot + 'vusers/' + store.getters.user.id + '/cards/', data)
// }

// export function deleteCard (card) {
//   return instance.delete(CONSTANTS.apiRoot + 'vusers/' + store.getters.user.id + '/cards/?id_card=' + card)
// }



// WEBPACK FOOTER //
// ./src/services/auth.js